import { Card } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { numberWithCommas } from 'utils/NumberCommaSeprator';
import { LoadingAnimation } from 'components/common';

const CardContainer = styled(Card)`
	height: 100%;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
`;

const CountNumber = styled.span`
	font-size: 40px;
	font-weight: 500;
	font-family: 'Montserrat';
`;

function TotalCities({ totalCities, isLoading }) {
	const cityCount = totalCities?.total || 0;

	return (
		<CardContainer>
			{isLoading ? (
				<LoadingAnimation visible={isLoading} animationID="TotalCitiesLoader" />
			) : (
				<>
					<CountNumber>{numberWithCommas(cityCount)}</CountNumber>
					<p>Total City</p>
				</>
			)}
		</CardContainer>
	);
}

TotalCities.propTypes = {
	totalCities: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default TotalCities;
